import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Box } from "@material-ui/core";
import { BarChart as BarChartIcon } from "@material-ui/icons";
import Group from "../../../waybee-ui/Group";
import Heading from "../../../waybee-ui/Heading/Heading";
import Loading from "../../../components/Loading";

const IframeContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

const StyledIframe = styled.iframe`
  opacity: ${props => (props.isLoading ? 0 : 1)};
  transition: opacity 0.3s;
  width: 100%;
  height: calc(100% + 60px); /* Adiciona espaço extra para "cortar" o footer */
  border: none;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: white;
  padding: 20px;
`;

class GroupCharts extends Component {
  state = {
    isIframeLoading: true
  };

  handleIframeLoad = () => {
    this.setState({ isIframeLoading: false });
  };

  render() {
    const { isIframeLoading } = this.state;
    const { loading, reportsDashboard } = this.props;

    return (
      <Group>
        <Heading level={2} icon={BarChartIcon} gutterBottom>
          Medidores de engajamento da comunicação
        </Heading>

        {loading ? (
          <Loading />
        ) : (
          <Box py={2} position="relative" height="800px">
            {reportsDashboard && (
              <IframeContainer>
                <StyledIframe
                  title="Metabase - Relatório de Engajamento"
                  src={reportsDashboard}
                  frameBorder={0}
                  allowTransparency
                  onLoad={this.handleIframeLoad}
                  isLoading={isIframeLoading}
                />
              </IframeContainer>
            )}
            {isIframeLoading && (
              <LoadingOverlay>
                <Loading />
              </LoadingOverlay>
            )}
            {!reportsDashboard && (
              <Box p={2}>Relatório não disponível para esta comunicação.</Box>
            )}
          </Box>
        )}
      </Group>
    );
  }
}

GroupCharts.propTypes = {
  loading: PropTypes.bool,
  reportsDashboard: PropTypes.string
};

GroupCharts.defaultProps = {
  loading: false,
  reportsDashboard: null
};

export default GroupCharts;
